import React, { useEffect, useState } from 'react';
import { statsService } from '../services/api';
import styles from './StatsDashboard.module.css';

export default function StatsDashboard() {
    const [overview, setOverview] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        statsService.overview()
            .then((ov) => setOverview(ov.data))
            .catch(console.error)
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div className={`${styles.loading} text-ar`}>جاري تحميل الإحصائيات...</div>;

    return (
        <div className={`${styles.wrap} text-ar`}>
            {overview && (
                <div className={styles.overviewGrid}>
                    <StatCard label="آخر 7 أيام" value={overview.last_7_days} color="var(--accent)" />
                    <StatCard label="آخر 30 يوماً" value={overview.last_30_days} color="var(--accent-secondary)" />
                    <StatCard label="الإجمالي" value={overview.total} color="var(--success)" />
                </div>
            )}
        </div>
    );
}

function StatCard({ label, value, color }) {
    return (
        <div className={styles.statCard} style={{ '--card-color': color }}>
            <p className={styles.statLabel}>{label}</p>
            <p className={styles.statValue} style={{ color }}>{value ?? '—'}</p>
        </div>
    );
}
